import { Delete } from "@mui/icons-material";
import { FC } from "react";
import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

import { MuiUploadButton } from "../buttons";

interface IUploadFileProps {
  disabled?: boolean;
  loading?: boolean;
  accept?: string;
  file?: File;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
}

const UploadFileStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "upload-file",
})`
  label {
    width: 100%;
  }

  .file-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-top: 10px;
  }

  .file-name {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .file-remove {
    cursor: pointer;
  }
`;

export const UploadFile: FC<IUploadFileProps> = ({
  disabled,
  loading,
  accept,
  file,
  onChange,
  onClear,
}) => {
  const handleChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ): Promise<void> => {
    await onChange(event);
    // Reset so selecting the same file again triggers onChange
    event.target.value = "";
  };

  return (
    <UploadFileStyled>
      <MuiUploadButton
        accept={accept}
        loading={loading}
        disabled={disabled}
        onChange={handleChange}
      />
      {file && (
        <div className="file-info">
          <div className="file-name">{file.name}</div>
          <div className="file-remove">
            <Delete
              data-e2e="file-remove-icon"
              className="close"
              onClick={onClear}
            />
          </div>
        </div>
      )}
    </UploadFileStyled>
  );
};
